export default {
  app_name: 'UpMobil +',
  categoriesList: 'Categorii',
  labelsList: 'Etichete',
  treeList: 'Tree'
}
